<template>
  <!-- <div class="page-wrapper"> -->

  <!-- ============================================================== -->
  <!-- Bread crumb and right sidebar toggle -->
  <!-- ============================================================== -->
  <!-- <div class="page-breadcrumb">
      <div class="col-md-5 align-self-center">
        <h6 class="page-title">Change Password</h6>
      </div>
    </div> -->
  <!-- ============================================================== -->
  <!-- End Bread crumb and right sidebar toggle -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Container fluid  -->
  <!-- ============================================================== -->
  <div class="container-fluid pt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <h4 class="p-b-20">{{$t("change_pwd")}}</h4>

    <div class="col-lg-5 pl-0">
      <div
        v-if="mssg"
        align="center"
        class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
      >
        <p class="alert-close mb-0">
          {{ mssg }}
        </p>
      </div>
      <div
        v-else-if="Errormssg"
        align="center"
        class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
      >
        <p class="alert-close mb-0">
          {{ Errormssg }}
        </p>
      </div>
      <form @submit.prevent="updatepassword">
        <div class="form-group">
          <label>{{$t("old_pwd")}}</label>
          <input
            type="password"
            name="old_password"
            v-model="oldpassword"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label>{{$t("new_pwd")}}</label>
          <input
            type="password"
            name="password"
            v-model="newpassword"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label>{{$t("new_pwd_2")}}</label>
          <input
            type="password"
            name="confirm_password"
            v-model="confirmpassword"
            class="form-control"
            required
          />
          <p class="small gray4">
            {{$t("strong-pwd")}}
          </p>
        </div>
        <p v-if="ErrorPass" class="small text-error p-1">
          {{ ErrorPass }}
        </p>
        <div
          style="height: 0.25rem; border-radius: 5px"
          :class="getClass()"
        ></div>
        <div class="row m-t-20">
          <div class="form-group col-md-4">
            <button type="submit" class="btn btn-primary">{{$t("save")}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Container fluid  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- footer -->
  <!-- ============================================================== -->
  <!-- <footer class="footer text-center">
      &#169; 2021 Gricd. All Rights Reserved
    </footer> -->
  <!-- ============================================================== -->
  <!-- End footer -->
  <!-- ============================================================== -->
  <!-- </div> -->
</template>

<script>
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "ChangePassword",
  data() {
    return {
      oldpassword: "",
      newpassword: "",
      confirmpassword: "",
      isLoading: false,
      fullPage: true,
      mssg: "",
      ErrorPass: "",
      Errormssg: "",
    };
  },
  components: {
    Loading,
  },
  computed: {
    scorePassword() {
      let score = 1;
      let password = "";
      for (let i = 0; i < this.newpassword.length; i++) {
        if (this.newpassword[i] === this.confirmpassword[i]) {
          password += this.newpassword[i];
        } else {
          break;
        }
      }
      // //console.log(password, "password")
      // //console.log(password.length)
      if (password === "") return score;
      if (password.length >= 8) {
        score++;
      }
      let variations = [
        /\d/.test(password),
        /[a-z]/.test(password),
        /[A-Z]/.test(password),
        /\W/.test(password),
      ];
      for (let i = 0; i < variations.length; i++) {
        if (variations[i] === true) {
          score++;
        }
      }
      // //console.log(score, "score");
      return parseInt(score);
    },
  },
  methods: {
    ...mapActions(["updatePassword"]),
    getClass() {
      if (this.scorePassword < 2) return "bg-gray2 w-100";
      if (this.scorePassword == 2) return "bg-danger w-25";
      else if (this.scorePassword == 3 || this.scorePassword == 4)
        return "bg-orange w-50";
      else if (this.scorePassword == 5) return "bg-warning w-75";
      else if (this.scorePassword == 6) return "bg-success w-100";
    },
    updatepassword() {
      this.Errormssg = "";
      this.ErrorPass = "";
      if (this.newpassword !== this.confirmpassword) {
        this.ErrorPass = "Passwords don't match";
        //console.log(this.ErrorPass);
      } else if (this.newpassword.length < 8) {
        this.ErrorPass = "Password has to be at least 8 characters";
      } else if (this.scorePassword < 5) {
        this.ErrorPass =
          "Password must contain at least one uppercase, one lowercase, and one special character";
      }
      if (
        this.newpassword === this.confirmpassword &&
        this.scorePassword >= 5 &&
        this.newpassword.length >= 8
      ) {
        this.isLoading = true;
        const updatedpassword = {
          oldPassword: this.oldpassword,
          newPassword: this.newpassword,
        };
        this.updatePassword(updatedpassword)
          .then((res) => {
            this.isLoading = false;
            this.oldpassword = "";
            this.newpassword = "";
            this.confirmpassword = "";
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
            setTimeout(() => {
              this.mssg = "";
            }, 4000);
            //console.log(res.data.message);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            // error.response can be null
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
  },
};
</script>


<i18n>
{
	"en": {
		"change_pwd": "Change Password",
		"new_pwd": "New Password",
		"new_pwd_2": "Re-enter New password",
		"old_pwd": "Old Password",
		"strong-pwd": "Strong passwords should be 8 characters long with a mix of upper case, lower case, and special characters"
	},
	"es": {
		"change_pwd": "Cambia la contraseña",
		"new_pwd": "Nueva contraseña",
		"new_pwd_2": "Re-ingrese nueva contraseña",
		"old_pwd": "Contraseña anterior",
		"strong-pwd": "Las contraseñas seguras deben tener 8 caracteres con una combinación de mayúsculas, minúsculas y caracteres especiales."
	},
	"fr": {
		"change_pwd": "Changer le mot de passe",
		"new_pwd": "nouveau mot de passe",
		"new_pwd_2": "Ré-entrez le nouveau mot de passe",
		"old_pwd": "ancien mot de passe",
		"strong-pwd": "Les mots de passe forts doivent comporter 8 caractères avec un mélange de majuscules, de minuscules et de caractères spéciaux"
	},
	"sw": {
		"change_pwd": "Badilisha neno la siri",
		"new_pwd": "Nenosiri mpya",
		"new_pwd_2": "Weka tena nenosiri Jipya",
		"old_pwd": "Namba ya siri ya zamani",
		"strong-pwd": "Nywila thabiti zinapaswa kuwa na urefu wa herufi 8 na mchanganyiko wa herufi kubwa, ndogo na herufi maalum"
	}
}
</i18n>